<div class="filter-wrapper">
  <!--  <h4>Options</h4>
    <div class="row">
      <div class="col-lg-8">
        <div class="row">
          <div class="col-lg-6">
            <div class="form-group">
              <label class="checkbox">
                <input type="checkbox"
                [(ngModel)]="innerSearchOptions.hideMyOwnedCompanies"
                (ngModelChange)="setSearchOptions(innerSearchOptions)">
                <span class="ms-3"><i class="far fa-dollar-sign"></i> Hide My Owned Companies</span>
              </label>
            </div>
            <div class="form-group">
              <label class="checkbox">
                <input type="checkbox"
                [(ngModel)]="innerSearchOptions.showOnlyDirectDials"
                (ngModelChange)="setSearchOptions(innerSearchOptions)">
                <span class="ms-3"><i class="fas fa-phone-volume"></i> Show Only Direct Dials</span>
              </label>
            </div>
            <div class="form-group">
              <label class="checkbox">
                <input type="checkbox"
                [(ngModel)]="innerSearchOptions.showInactiveCompanies"
                (ngModelChange)="setSearchOptions(innerSearchOptions)">
                <span class="ms-3"><i class="far fa-ban"></i> Show Inactive Companies</span>
              </label>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label>Show only companies updated:</label>
              <div class="control">
                  <select class="custom-select">
                      <option>Anytime</option>
                      <option>Anytime</option>
                      <option>Anytime</option>
                  </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <h4>Location</h4>
    <location-filter (changed)="filterLocation({ location: $event })"></location-filter>-->

    <h4>Refine Results</h4>
    <div class="filter-inner-wrapper">
      <div class="row">
        <div class="col-md-6">
          <h5>Industry</h5>
          <div class="filter-block" *ngIf="searchState.companySearch?.filters?.industry?.items">
            <advanced-filter-checkbox-list
                [items]="searchState.companySearch?.filters?.industry?.items"
                (changed)="filter({ industry: $event.items, filterName: 'industry' })">
            </advanced-filter-checkbox-list>
           </div>
        </div>
        <div class="col-md-6">
          <h5>Employees</h5>
          <div class="filter-block" *ngIf="searchState.companySearch?.filters?.employeeRange?.items">
            <advanced-filter-checkbox-list
                [items]="searchState.companySearch?.filters?.employeeRange?.items"
                (changed)="filter({ employeeRange: $event.items, filterName: 'employeeRange' })">
            </advanced-filter-checkbox-list>
          </div>
        </div>
        <div class="col-md-6">
          <h5>Revenue</h5>
          <div class="filter-block" *ngIf="searchState.companySearch?.filters?.revenueRange?.items">
            <advanced-filter-checkbox-list
                [items]="searchState.companySearch?.filters?.revenueRange?.items"
                (changed)="filter({ revenueRange: $event.items, filterName: 'revenueRange' })">
            </advanced-filter-checkbox-list>
           </div>
        </div>
      <!--  <div class="col-md-6">
          <h5>Ownership</h5>
          <div class="filter-block" *ngIf="searchState.companySearch?.filters?.ownership?.items">
            <advanced-filter-checkbox-list
                [items]="searchState.companySearch?.filters?.ownership?.items"
                (changed)="filter({ ownership: $event.items, filterName: 'ownership' })">
            </advanced-filter-checkbox-list>
           </div>
        </div>-->
        <div class="col-md-6">
          <h5>Websites</h5>
          <div class="filter-block">
            <filter-domain-list
              [items]="websites"
              (changed)="urlDomain($event.items)">
            </filter-domain-list>
          </div>
        </div>
        <div class="col-md-6">
          <h5>Country/State</h5>
          <div class="filter-block" *ngIf="searchState.companySearch?.filters?.country?.items">
            <advanced-filter-checkbox-list
                [items]="searchState.companySearch?.filters?.country?.items"
                (changed)="filter({ country: $event.items, filterName: 'country' })">
            </advanced-filter-checkbox-list>
           </div>
        </div>

      </div>
    </div>
    <div class="sort-btn mt-3 float-right">
      <button (click)="onSearch()" class="btn btn-action">Search</button>
      <button (click)="openDialog()" class="btn btn-action">Save</button>
    </div>
  </div>
